import {Image} from "../../../stem-core/ui/UIPrimitives.jsx";
import {Dispatcher} from "../../../stem-core/base/Dispatcher";

export class PanelImage extends Image {
    onMount() {
        this.addLoadListener(() => Dispatcher.Global.dispatch("iframeSizeChange"));
    }
}
